import styled from 'foundations-theming/utils';
import { MEETING_LINK_DOMAINS, SENDER_MEETINGS_LINK_TOKEN } from 'hubspot-prosemirror/draft-transplant/utils/constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo, useState } from 'react';
import MeetingsNotYoursTooltip from './MeetingsNotYoursTooltip';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const getIsYourMeetingLink = (meetingLinks, meetingURL) => {
  const linkSlug = MEETING_LINK_DOMAINS.reduce((fullUrl, domain) => {
    return fullUrl.indexOf(domain) !== -1 ? fullUrl.replace(domain, '') : fullUrl;
  }, meetingURL);
  const currentLink = meetingLinks.find(link => link.slug === linkSlug || link.link === meetingURL);
  return !!currentLink;
};
const StyledToken = styled.span.withConfig({
  displayName: "MeetingLink__StyledToken",
  componentId: "ut4buv-0"
})(["background-color:", ";border:1px solid ", ";border-radius:2px;color:", ";cursor:default;display:inline;line-height:1;margin:0;padding:4px 8px;vertical-align:middle;user-select:text;width:auto;"], ({
  theme
}) => theme.color['fill-info-subtle'], ({
  theme
}) => theme.color['fill-info-subtle'], ({
  theme
}) => theme.color['fill-info-default']);

// if the link was styled to a different color, we will override the default link color with it
const StyledLink = styled.span.withConfig({
  displayName: "MeetingLink__StyledLink",
  componentId: "ut4buv-1"
})(["color:", ";font-weight:600;text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.color['text-interactive-default']);
const MeetingLink = ({
  meetingName,
  meetingURL,
  meetingLinks,
  hasFetchMeetingDone,
  onClick
}) => {
  const [isLongformOpen, setIsLongformOpen] = useState(false);
  const handleClose = useCallback(() => {
    setIsLongformOpen(false);
  }, []);
  const toggleLongform = useCallback(() => {
    setIsLongformOpen(prevIsLongformOpen => !prevIsLongformOpen);
  }, []);
  const isYourMeetingLink = useMemo(() => getIsYourMeetingLink(meetingLinks, meetingURL), [meetingLinks, meetingURL]);
  if (meetingName === SENDER_MEETINGS_LINK_TOKEN) {
    return (
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized */
      _jsx(StyledToken, {
        onClick: onClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.sendermeetingslink"
        })
      })
    );
  }
  if (meetingURL === SENDER_MEETINGS_LINK_TOKEN) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.sendermeetingslink"
      }),
      children: /*#__PURE__*/_jsx(StyledLink, {
        onClick: onClick,
        children: meetingName
      })
    });
  }
  if (hasFetchMeetingDone && !isYourMeetingLink) {
    return /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      open: isLongformOpen,
      placement: "bottom",
      title: /*#__PURE__*/_jsx(MeetingsNotYoursTooltip, {
        meetingURL: meetingURL
      }),
      onClose: handleClose,
      maxInlineSize: "400px",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.meetingsLinkNotYours"
        }),
        defaultOpen: true,
        disabled: isLongformOpen,
        children: /*#__PURE__*/_jsx(StyledLink, {
          onClick: toggleLongform,
          children: meetingName
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.meetings.custommeetingslink"
    }),
    children: /*#__PURE__*/_jsx(StyledLink, {
      onClick: onClick,
      children: meetingName
    })
  });
};
export default MeetingLink;